/**
 * @generated SignedSource<<ffd10bf1e813973190ee211ffcaf6a57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UsersWhoMadeContentNodeTable_Fragment$data = {
  readonly Admin: {
    readonly UsersList: {
      readonly AllUsers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly extensions: ReadonlyArray<{
              readonly accountCode?: string | null | undefined;
              readonly firstName?: string | null | undefined;
              readonly lastName?: string | null | undefined;
            }>;
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"UserActionColumn_NodeFragment" | "UserContentSubmissionDialog_UserFragment" | "accountCodeColumn_Fragment" | "userNameColumn_Fragment">;
          };
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
          readonly hasPreviousPage: boolean;
          readonly startCursor: string | null | undefined;
        };
      };
    };
  };
  readonly " $fragmentType": "UsersWhoMadeContentNodeTable_Fragment";
};
export type UsersWhoMadeContentNodeTable_Fragment$key = {
  readonly " $data"?: UsersWhoMadeContentNodeTable_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UsersWhoMadeContentNodeTable_Fragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "Admin",
  "UsersList",
  "AllUsers"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentNodeId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByFirstName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByLastName"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./UsersWhoMadeContentNodeTable_Refetch.graphql')
    }
  },
  "name": "UsersWhoMadeContentNodeTable_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UsersListAdminSchema",
          "kind": "LinkedField",
          "name": "UsersList",
          "plural": false,
          "selections": [
            {
              "alias": "AllUsers",
              "args": [
                {
                  "kind": "Variable",
                  "name": "contentNodeId",
                  "variableName": "contentNodeId"
                },
                {
                  "kind": "Variable",
                  "name": "filterByFirstName",
                  "variableName": "filterByFirstName"
                },
                {
                  "kind": "Variable",
                  "name": "filterByLastName",
                  "variableName": "filterByLastName"
                }
              ],
              "concreteType": "UserConnection",
              "kind": "LinkedField",
              "name": "__UsersWhoMadeContentNodeTable_AllUsers_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasPreviousPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startCursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "extensions",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "firstName",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lastName",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "accountCode",
                                  "storageKey": null
                                }
                              ],
                              "type": "InfectopharmUserExtension",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "UserContentSubmissionDialog_UserFragment"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "userNameColumn_Fragment"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "UserActionColumn_NodeFragment"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "accountCodeColumn_Fragment"
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "b8239aa56a85360eba3ee8798bea9dda";

export default node;
